/**
 * 空状态组件：居中图标 + 文案 + 可选操作区。
 *
 * @module components/common/EmptyState
 */
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import InboxIcon from '@mui/icons-material/Inbox';
import type { ReactNode } from 'react';

/** EmptyState 属性。 */
export interface EmptyStateProps {
  /** 提示文案。 */
  message?: string;
  /** 可选操作区（如按钮）。 */
  action?: ReactNode;
  /** 最小高度。 */
  minHeight?: number | string;
}

/**
 * 空状态占位组件。
 *
 * @param props 组件属性。
 * @returns JSX 元素。
 */
export default function EmptyState({
  message = '暂无数据',
  action,
  minHeight = 200,
}: EmptyStateProps): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        minHeight,
        color: 'text.secondary',
      }}
    >
      <InboxIcon sx={{ fontSize: 48, opacity: 0.5 }} />
      <Typography variant="body2">{message}</Typography>
      {action}
    </Box>
  );
}
